import Vue from 'vue';

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.post('/chart_of_accounts/create')
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationSettings/createCOA.js